import { createAsyncThunk, createSlice,combineReducers } from "@reduxjs/toolkit";
import { BASE_URL } from "../config";
import { PatientList } from "../interfaces/Patients";


interface ParsedData {
  accessToken?: string;
}

interface PatientState {
  loading: boolean;
  user: any | null;
  error: string | null;
  isLoggedIn: boolean;
  data: PatientList[] | null;
}


const initialState: PatientState = {
  loading: false,
  user: null,
  error: null,
  isLoggedIn: false,
  data: null,
};


export const AllPatientList = createAsyncThunk(
  "patient/AllPatientList",
  async (_, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }
      
      const response = await fetch(`${BASE_URL}/api/v1/patients`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      });

       if (!response.ok) {
         return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
       }

      const result = await response.json();      
      return result.data.user;
      
    } catch (error: any) {
      console.error("Error fetching User Details:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);


const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder     
      .addCase(AllPatientList.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(AllPatientList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
      })
      .addCase(AllPatientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error creating payment intent:", action.payload); // Log the detailed error
      });
      
  },
});

export const { resetState } = patientSlice.actions;
export default patientSlice.reducer;
